import { createSlice } from "@reduxjs/toolkit";
import { toGetOffers } from "../actions/offers.actions";

const initialState = {
  offers: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const offersSlice = createSlice({
  name: "offers",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetOffers.pending, (state) => {
      state.offers = { list: [], status: "idle" };
    });
    builder.addCase(toGetOffers.fulfilled, (state, action) => {
      state.offers = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetOffers.rejected, (state, action) => {
      state.offers = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default offersSlice.reducer;
